import { Modal } from "bootstrap";
import { post } from "jquery";
import prestashop from "./prestashop";

declare global {
    interface Window {
        grecaptcha: any;
        autoplikis_recaptcha_onLoadCallback?: () => void;
    }
}

function customValidations() {
    //set custom validity message to "Privalomas laukelis"
    document.querySelectorAll('#inquireModal form input[required]')?.forEach((input) => {
        (input as HTMLInputElement).setCustomValidity('Privalomas laukelis');
    });
    
    //check if input is not empty
    document.querySelectorAll('#inquireModal form input[required]')?.forEach((input) => {
        input.addEventListener('input', (event) => {
            const input = event.target as HTMLInputElement;
            //set custom validity message to "Privalomas laukelis"
            input.setCustomValidity('Privalomas laukelis');
            //check if input is not empty
            if (input.value) {
                //remove custom validity message
                input.setCustomValidity('');
            }
        });
    }
    );
}



var ETS_RCF_GOOGLE_CAPTCHA_SITE_KEY = '6LdgUqwrAAAAAF6vST26813cotcMMOQGda0dXDf_';
var recaptchaWidgets: any[] = [];

window.autoplikis_recaptcha_onLoadCallback = function () {
    console.log('autoplikis_recaptcha_onLoadCallback called');

    if(document.querySelector("#inquireModal .g-recaptcha") !== null) {
        var widget_id = window.grecaptcha.render(document.querySelector("#inquireModal .g-recaptcha"), {
            'sitekey': ETS_RCF_GOOGLE_CAPTCHA_SITE_KEY,
            'theme': 'light',
        });
        recaptchaWidgets.push(widget_id);
    }
    
    //maybe load standalone inquiry form recaptcha
    if (document.body.id === 'module-autoplikisforms-inquiry' && document.querySelector(".autoplikisinquiryform-wrapper .g-recaptcha")) {
        console.log('Loading standalone inquiry form reCAPTCHA');
        var widget_id = window.grecaptcha.render(document.querySelector(".autoplikisinquiryform-wrapper .g-recaptcha"), {
            'sitekey': ETS_RCF_GOOGLE_CAPTCHA_SITE_KEY,
            'theme': 'light',
        });
        recaptchaWidgets.push(widget_id);
    }
};

function loadRecaptcha() {
    // Add Google reCAPTCHA script if not already present
    if (!document.querySelector('script[src*="recaptcha/api.js"]')) {
        const script = document.createElement('script');
        script.src = "https://www.google.com/recaptcha/api.js?onload=autoplikis_recaptcha_onLoadCallback&render=explicit&hl=lt";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }
}

async function loadForm() {

    const modalDialogElement = document.querySelector('#inquireModal');
    if (!modalDialogElement) return;
    
    const modalHeaderElement = modalDialogElement.querySelector('.modal-header');
    if (modalHeaderElement) {
        modalHeaderElement.innerHTML = `
            <h1 class="modal-title" id="inquireModalLabel">Prekių užklausa</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z" stroke="#0B253C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15 9.5L9 15.5" stroke="#0B253C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 9.5L15 15.5" stroke="#0B253C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            </button>
        `;
    }

    const myModalAlternative = new Modal(modalDialogElement, {});

    const datas = await fetch("/uzklausa?is_ajax=1", {
        method: 'GET'
    });
    var content = await datas.text();
    const modalBodyElement = modalDialogElement.querySelector('.modal-body');
    if (modalBodyElement) {
        modalBodyElement.innerHTML = content;
    }
    
    
    loadRecaptcha();

    
    document.querySelector('#inquireModal form')?.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(event.target as HTMLFormElement);
        data.append('submitMessage', '1');

        //post ajax request
        fetch("/uzklausa?is_ajax=1", {
            method: 'POST',
            body: data
        }).then((response) => {
            return response.text();
        }).then((data) => {
            //replace modal body with response
            const modalBodyElement = modalDialogElement.querySelector('.modal-body');
            if (modalBodyElement) {
                modalBodyElement.innerHTML = data;
            }
        });
        return false;
    });
    
    //if we closed and reopened the modal, we need to reinitialize the recaptcha
    if (window.grecaptcha && recaptchaWidgets.length < 1) {
        console.log('Reinitializing reCAPTCHA');
        if (typeof window.autoplikis_recaptcha_onLoadCallback === 'function') {
            window.autoplikis_recaptcha_onLoadCallback();
        }
    }
    myModalAlternative.show();
}

async function loadProductInquiryForm() {

    const modalDialogElement = document.querySelector('#inquireModal');
    if (!modalDialogElement) return;

    const myModalAlternative = new Modal(modalDialogElement, {});

    const datas = await fetch("/uzklausa?is_ajax=1", {
        method: 'GET'
    });
    var content = await datas.text();
    const modalBodyElement = modalDialogElement.querySelector('.modal-body');
    if(!modalBodyElement)
        return;

    modalBodyElement.innerHTML = content;
    
    loadRecaptcha();
    
    const productName = document.querySelector<HTMLElement>('.product .product__name');
    var replaceObj = document.querySelector<HTMLElement>('[data-replacewith="product_name"]');
    const productNameField = modalBodyElement.querySelector<HTMLInputElement>('[name="product_name"]');
    const productUrlField = modalBodyElement.querySelector<HTMLInputElement>('[name="product_url"]');
    
    if(!productName || !replaceObj || !productNameField || !productUrlField) return;
    
    modalBodyElement.querySelector('.product-inquiry-wrap')?.classList.remove('d-none');
    //replace [data-replacewith="product_name"] with actual product name
    
    replaceObj.innerText = productName.innerText;
    productNameField.value = productName.innerText;
    productUrlField.value = window.location.href;


    document.querySelector('#inquireModal form')?.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(event.target as HTMLFormElement);
        data.append('submitMessage', '1');

        //post ajax request
        fetch("/uzklausa?is_ajax=1", {
            method: 'POST',
            body: data
        }).then((response) => {
            return response.text();
        }).then((data) => {
            //replace modal body with response
            const modalBodyElement = modalDialogElement.querySelector('.modal-body');
            if (modalBodyElement) {
                modalBodyElement.innerHTML = data;
            }
        });
        return false;
    });
    myModalAlternative.show();
}

function checkoutPageOpenLoginModal() {
    const modalDialogElement = document.querySelector('#loginModal');
    if (!modalDialogElement) return;

    const myModalAlternative = new Modal(modalDialogElement, {});
    myModalAlternative.show();
}

const autoplikisModals = (): void => {
    document.querySelector('[data-action="openinquirymodal"]')?.addEventListener("click", (event) => {
        event.preventDefault();
        //if we are on the standalone inquiry form, just scroll to the form
        if (document.body.id === 'module-autoplikisforms-inquiry') {
            document.querySelector('.autoplikisinquiryform-wrapper')?.scrollIntoView({ behavior: 'smooth' });
            return false;
        }
        loadForm();
        return false;
    });


    document.querySelector('[data-action="openproductinquirymodal"]')?.addEventListener("click", (event) => {
        event.preventDefault();
        loadProductInquiryForm();
        return false;
    });
    
    document.querySelector('[data-action="checkoutPageOpenLoginModal"]')?.addEventListener("click", (event) => {
        event.preventDefault();
        checkoutPageOpenLoginModal();
        return false;
    });
    
    // Listen for the custom event from The Checkout module
    document.addEventListener('thecheckout_setSelectedPaymentOption', function (event) {
        const data = (event as CustomEvent).detail;
        console.log('thecheckout_setSelectedPaymentOption event triggered', data);
        // Check if the selected payment option is wirepayment
        if (data && data.option && data.option.indexOf('ps_wirepayment') !== -1) {
            // Show the modal
            const bankwireModal = document.getElementById('bankwire-modal');
            if (bankwireModal) {
                const modal = new Modal(bankwireModal);
                modal.show();
            }
        }
    });
    
    
    window.prestashop.on('thecheckout_setSelectedPaymentOption', (event: any) => {
        //check if there's bankwire-modal in <footer>. If not - move it from .additional-information.ps_wirepayment
        
        const bankwireModal = document.querySelector('#footer #bankwire-modal');
        if (!bankwireModal) {
            const additionalInfo = document.querySelector('.additional-information.ps_wirepayment #bankwire-modal');
            if (additionalInfo) {
                const footer = document.querySelector('#footer');
                if (footer) {
                    footer.appendChild(additionalInfo);
                    console.log('Moved bankwire-modal to footer');
                }
            }
        }
        
        // Re-attach your modal open handler here if needed
        document.querySelectorAll('[data-toggle="modal"][data-target="#bankwire-modal"]').forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation(); // Prevent the event from bubbling up
                const bankwireModal = document.querySelector('#footer #bankwire-modal');
                if (bankwireModal) {
                    const modal = new Modal(bankwireModal);
                    modal.show();
                }
            });
        });
    });
    document.addEventListener('DOMContentLoaded', () => {
    if (window.prestashop && typeof window.prestashop.on === 'function') {
        window.prestashop.on('thecheckout_setSelectedPaymentOption', function (data: any) {
        // Check if the selected payment option is wirepayment
        if (data && data.option && data.option.indexOf('ps_wirepayment') !== -1) {
            // Show the modal
            const bankwireModal = document.getElementById('bankwire-modal');
            if (bankwireModal) {
            const modal = new Modal(bankwireModal);
            modal.show();
            }
        }
        });
    }
    });
    
    //load recaptcha script if we are also in a standalone inquiry form
    if (document.body.id === 'module-autoplikisforms-inquiry') {
        loadRecaptcha();
    }
}

export default autoplikisModals;
